import { Injectable } from "@angular/core"
import { environment } from "src/environments/environment"
import { Grade } from "../models/grade/grade"
import { DEFAULT_PAGE_SIZE } from "../lib/constants"
import { HttpClient, HttpParams } from "@angular/common/http"
import {
  CustomURLEncoder,
  isNullOrUndefined,
} from "src/app/core/helpers/http-params-extensions"

@Injectable()
export class GradeService {
  private post_grade_url: string
  private get_grade_url: string
  private get_grade_id_url: string
  private put_grade_url: string
  private get_grouped_grade_url: string
  private get__grade_segment_url: string

  constructor(private httpClient: HttpClient) {
    this.buildUrls(environment.endpointGrade.url)
  }

  private buildUrls(gradeUrl: string) {
    this.post_grade_url = gradeUrl + environment.endpointGrade.routes.post_grade
    this.get_grade_id_url =
      gradeUrl + environment.endpointGrade.routes.get_grade_id
    this.get_grade_url = gradeUrl + environment.endpointGrade.routes.get_grade
    this.put_grade_url = gradeUrl + environment.endpointGrade.routes.put_grade
    this.get_grouped_grade_url =
      gradeUrl + environment.endpointGrade.routes.get_grouped_grade_url
    this.get__grade_segment_url =
      gradeUrl + environment.endpointGrade.routes.get_grade_segment_id
  }

  postgrade(grade: Grade) {
    return this.httpClient.post(this.post_grade_url, grade)
  }

  getOne(gradeId: string) {
    return this.httpClient.get(
      this.get_grade_id_url.replace("{gradeId}", gradeId)
    )
  }

  getGradeBySegmentId(segmentId: string, schoolId: string) {
    const params = new HttpParams({ encoder: new CustomURLEncoder() })
      .set("segmentId", segmentId)
      .set("schoolId", schoolId)

    return this.httpClient.get(this.get__grade_segment_url, { params })
  }

  getAllgrades(grade: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })
    if (grade.gradeName) {
      params = params.set("gradeName", grade.gradeName)
    }
    if (grade.gradeAlias) {
      params = params.set("gradeAlias", grade.gradeAlias)
    }
    if (grade.orderByFilter) {
      params = params.set("orderByFilter", grade.orderByFilter)
    }
    if (grade.schoolId) {
      params = params.set("schoolId", grade.schoolId)
    }
    params = params.set(
      "askPage",
      !isNullOrUndefined(grade.askPage) ? String(grade.askPage) : "1"
    )
    params = params.set(
      "itensPerPage",
      !isNullOrUndefined(grade.itensPerPage)
        ? String(grade.itensPerPage)
        : String(DEFAULT_PAGE_SIZE)
    )
    params = params.set("IsDesc", String(grade.isDesc))

    return this.httpClient.get(this.get_grade_url, { params })
  }

  getGradeGrouped() {
    return this.httpClient.get(this.get_grouped_grade_url)
  }

  putgrade(grade: Grade) {
    return this.httpClient.put(
      this.put_grade_url.replace("gradeId", grade.id),
      grade
    )
  }
}
